export const SET_POBLACIONES = 'SET_POBLACIONES';
export const SET_PAISES_PRESTA = 'SET_PAISES_PRESTA';

